import * as moment from 'moment';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useLocalize } from './useLocalize';

// Used to initialize i18n and momentjs with the current workspace locale.
export const useWorkspaceLocale = () => {
	const { i18n } = useTranslation();
	const { language } = useLocalize();
	const [cache, setCache] = useState<string | undefined>(undefined);

	// Initialize i18n and momentjs on load and when the locale changes.
	const setLocale = useCallback(
		(locale: string) => {
			const language = locale.split('_')[0];
			i18n.changeLanguage(language);
			moment.locale(language);
		},
		[i18n],
	);

	useEffect(() => {
		if (cache !== language.id) {
			setCache(language.id);
			setLocale(language.id);
		}
	}, [cache, language.id, setLocale]);

	return { setLocale };
};
